<app-dc-header class="headerContainer">
  <ng-container class="heading">Privacy Policy Notice</ng-container>
</app-dc-header>

<app-dc-pane noHeader="true" class="mainContainer"> <div class="modal-body" [innerHTML]="text"></div></app-dc-pane>
